/**
 * DidiJSBridge 初始化
 * @author xuxiaoyan
 */
import { isIOS, each } from '../util'

let cbs = []

function iosInit () {
  if (window.DidiJSBridge && window.DidiJSBridge.init) {
    try {
      /**
       * 注意 init 只能调用一次，如果页面中调用多次，会抛出 error
       * 无法捕获这个 error，因为这个 error 是异步的
       */
      window.DidiJSBridge.init()
    } catch (e) {
    }
  }
}

function init() {

  if (window.DidiJSBridge) {
    isIOS && iosInit()
  } else {
    document.addEventListener('DidiJSBridgeReady', onBridgeReady, false)
  }

}

function onBridgeReady() {
  isIOS && iosInit()

  each(cbs, cb => {
    cb(window.DidiJSBridge)
  })
}

setTimeout(() => {
  init()
})

 
/**
 * Hack for webview script
 * Fuck all of them
 */
window.Fusion = window.Fusion || {}
// window.DidiJSBridge = window.DidiJSBridge || {}
window.DidiBeatlesJSBridge = window.DidiBeatlesJSBridge || {}

export function bridgeReady(callback) {
  if (window.DidiJSBridge) {
    // 注册回调事件
    callback(window.DidiJSBridge)
  } else {
    cbs.push(callback)
  }

}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/core/bridge.js